"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __1 = require("../");
/** [[include:component/click-and-collect-list.md]] */
var ClickAndCollectList = /** @class */ (function (_super) {
    __extends(ClickAndCollectList, _super);
    function ClickAndCollectList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClickAndCollectList.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null, this.context.clickAndCollect.markers.map(function (marker) { return _this.props.children(marker, marker.id === _this.context.clickAndCollect.selected); })));
    };
    ClickAndCollectList.contextType = __1.Context;
    return ClickAndCollectList;
}(React.Component));
exports.ClickAndCollectList = ClickAndCollectList;
//# sourceMappingURL=click-and-collect-list.js.map